import React from "react";
import styled from "styled-components";
import Brightness3Icon from "@material-ui/icons/Brightness3";
import WbSunnyIcon from "@material-ui/icons/WbSunny";
import CloseIcon from "@material-ui/icons/Close";
import { navMenu } from "../data";
import { Link, animateScroll as scroll } from "react-scroll";
import { ThemeSwitcher } from "../ThemeSwitcher";
import MenuIcon from "@material-ui/icons/Menu";
import { Balls } from "./Balls";

function Header({ switchTheme, theme }) {
  const themesColors = React.useContext(ThemeSwitcher);
  let defaultTheme = localStorage.getItem("theme");

  const [openMenu, setOpenMenu] = React.useState(false);

  const handleMenu = () => {
    setOpenMenu((prev) => !prev);
  };

  React.useEffect(() => {
    localStorage.setItem("theme", theme);
  }, [theme]);

  React.useEffect(() => {
    if (defaultTheme === null) {
      defaultTheme = "light";
    } else {
      switchTheme(defaultTheme);
    }
  }, []);

  const handleSwitchTheme = () => {
    if (theme === "light") {
      switchTheme("dark");
    } else {
      switchTheme("light");
    }
  };

  return (
    <>
      <Balls theme={theme} />

    <Container>
      <Menu>
        <NavMenu>
          {navMenu.map((li, index) => (
            <li key={index}>
              <Link
                className="nav__link"
                to={li}
                spy={true}
                smooth={true}
                offset={-70}
                duration={1000}
              >
                {li}
              </Link>
            </li>
          ))}
        </NavMenu>
        <ThemesSwitch onClick={handleSwitchTheme}>
          {theme === "dark" ? <SunIcon /> : <MoonIcon />}
        </ThemesSwitch>
        <Burger onClick={handleMenu}>
          <MenuIcon />
        </Burger>
      </Menu>
      <RightMenu show={openMenu}>
        <CloseMenu onClick={handleMenu}>
          <Cross />
        </CloseMenu>
        {navMenu.map((li, index) => (
          <li key={index}>
            <Link
              onClick={handleMenu}
              activeClass="active"
              type="submit"
              to={li.eng}
              spy={true}
              smooth={true}
              offset={50}
              duration={1000}
            >
              {li.ru}
            </Link>
          </li>
        ))}
      </RightMenu>
    </Container>
    </>

  );
}

export default Header;

const Container = styled.div`
  margin: 0 auto;
  max-width: 1400px;
  position: fixed;
  background: ${(themesColors) => themesColors.theme.back};
  right: 0;
  top: 90px;
  left: 0;
  color: white;
  height: 70px;
  z-index: 1;
  font-size: 20px;
  font-weight: 700;
  @media (max-width: 768px) {
    display:none;
  }
  a {
    text-decoration: none;
    text-transform: uppercase;
    color: ${(themesColors) => themesColors.theme.title};
    &:hover {
      color: ${(themesColors) => themesColors.theme.url};
    }
  }
`;

const Logo = styled.div``;

const NavMenu = styled.nav`
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  @media (max-width: 768px) {
    display: none;
  }
    margin-left: 20px;
    li {
      margin-left: 20px;
      a {
        display: inline-block;
        text-decoration: none;
        color: ${(themesColors) => themesColors.theme.title};
        position: relative;
        &::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 2px;
          background-color: ${(themesColors) => themesColors.theme.url};
          transform: scaleX(0);
          transform-origin: right;
          transition: transform .5s;
        }
        &:hover::after {
          transform: scaleX(1);
          transform-origin: left;
        }
  }
  }
`;
const Burger = styled.div`
  svg {
    color: ${(themesColors) => themesColors.theme.title};
  }
  cursor: pointer;
  width: 25px;
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

const ThemesSwitch = styled.div`
  cursor: pointer;
`;

const MoonIcon = styled(Brightness3Icon)`
  color: #6d6c6c;
  transform: rotate(0deg);
  transition:transform .5s ease 0s,color .3s linear 0s;
  &:hover {
  transition: all .5s ease 0s;
    transform: rotate(40deg);
    color: #ffee01;
  }
`;
const SunIcon = styled(WbSunnyIcon)`
  color: #ffee01;
  &:hover {
  transition: all 1s ease 0s;
    transform: rotate(360deg);
  }
`;

const RightMenu = styled.div`
  display: none;
  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    background: ${(themesColors) => themesColors.theme.back};

    width: 300px;
    z-index: 15;
    list-style: none;
    padding: 20px;
    display: flex;
    flex-direction: column;
    text-align: center;
    transform: ${(props) =>
      props.show ? `translateX(0)` : `translateX(100%)`};
    transition: transform 0.2s ease-in;
    li {
      cursor: pointer;
      padding: 15px 0;
      border-bottom: 1px solid ${(themesColors) => themesColors.theme.title};
      a {
        color: ${(themesColors) => themesColors.theme.title};
        font-weight: 600;
      }
    }
  }
`;

const Menu = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 calc(70vw - 60vw);
  height: 100%;
  a {
    cursor: pointer;
  }
`;

const CloseMenu = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Cross = styled(CloseIcon)`
  cursor: pointer;
  color: ${(themesColors) => themesColors.theme.title};
`;
